import CMSAPI from "@/services/api/contentManagmentApi";
import draggable from "vuedraggable";
import homepageUtils from "../contentManagmentUtils";
import BrandApi from "@/services/api/brandApi";

const { getFeaturedBrands, updateFeaturedBrands } = new CMSAPI(),
  BrandApiService = new BrandApi();

export default {
  components: {
    draggable,
  },
  data() {
    return {
      featuredBrandsList: [],
      showAddBrand: false,
    };
  },
  mounted() {
    getFeaturedBrands().then((response) => {
      this.featuredBrandsList = response.data;
    });
  },
  methods: {
    handleAddBrandClick,
    handleSelectChange,
    handleSave,
  },
};

async function handleSelectChange(item) {
  const duplicate = this.featuredBrandsList.filter((brand) => brand.entity_id === item.id);

  if (!duplicate.length) {
    const { data } = await BrandApiService.getBrand(item.id),
      brand = {
        name: data.brand_name,
        image_url: data.thumbnail_image_url,
        id: data.id,
        entity_id: data.id,
        mov: data.minimum_order_value,
        vanity_url_name: data.vanity_url_name,
      };

    this.featuredBrandsList.push(brand);
    this.showAddBrand = false;
  }
}

function handleAddBrandClick() {
  this.showAddBrand = true;
}

function handleSave() {
  this.featuredBrandsList = homepageUtils.truncate(this.featuredBrandsList);
  updateFeaturedBrands({
    view_components: this.featuredBrandsList.map((component, i) => ({
      component_type: "BRAND",
      entity_id: component.entity_id,
      ordinal: i + 1,
      attributes: {
        image_url: component.image_url,
        name: component.name,
        mov: component.mov,
        vanity_url_name: component.vanity_url_name,
      },
    })),
  })
    .then(() => this.$swal("Success: Featured Brands Saved"))
    .catch((error) =>
      error.response
        ? this.$swal("Attention", error.response.data.error_message)
        : this.$logger.notify(new Error(error))
    );
}
